import { connect } from 'react-redux';
import { unhideComment } from '../Comment/redux/actionCreators';
import { isCommentReduxReady } from '../Comment/redux/selectors';
const mapStateToProps = (state)=>({
        isCommentReduxReady: isCommentReduxReady(state)
    });
const mapDispatchToProps = {
    onUnhide: unhideComment
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=CommentDeleteNotification.container.js.map